import { Routes, Route, Link } from 'react-router-dom';
import Landing from './pages/Landing.jsx';
import Create from './pages/Create.jsx';
import Result from './pages/Result.jsx';
import About from './pages/About.jsx';
import Privacy from './pages/Privacy.jsx';
import Footer from './components/Footer.jsx';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-atlas-paper">
      <header className="bg-atlas-navy text-white">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 no-underline min-w-0">
            <span className="inline-block w-1 h-6 bg-atlas-gold flex-shrink-0" aria-hidden="true" />
            <span className="text-white font-medium tracking-tight truncate">
              MAPTRIUM™
              <span className="hidden sm:inline text-white/60 font-normal"> &middot; Instant Demo</span>
            </span>
          </Link>
          <nav className="text-sm flex items-center gap-4 sm:gap-5">
            <Link to="/create" className="text-white/90 hover:text-atlas-gold no-underline">Create</Link>
            <Link to="/about" className="text-white/90 hover:text-atlas-gold no-underline hidden sm:inline">About</Link>
            <a
              href="https://maptrium.com/login"
              className="text-white/90 hover:text-atlas-gold no-underline hidden sm:inline"
            >
              Sign in
            </a>
            <a
              href="https://maptrium.com/"
              className="inline-flex items-center gap-1 bg-atlas-gold text-atlas-navy font-medium px-3 py-1.5 rounded-md no-underline hover:bg-atlas-gold-dark transition-colors"
            >
              Open MAPTRIUM <span aria-hidden="true">→</span>
            </a>
          </nav>
        </div>
      </header>
      <main id="main" className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/create" element={<Create />} />
          <Route path="/d/:shortId" element={<Result />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
